/// <reference path="callCenter.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CallCenter {
  
  class BookAppointmentModalController {
    
    private scope: any;
    private modal: angular.material.IDialogService;
    private message: string;
    private modalClass: string;
    private okButtonContentKey: string;
    private cancelButtonContentKey: string;
    private headerContentKey: string;
    private services: Array<Object>;
    private showEmpName : boolean;
    private bookAppointmentSecurityKey: string;

    static $inject = ["$scope", "$mdDialog", "meevo.components.common.DataService", "message", "services", "location", "showEmpName"];

    constructor($scope: angular.IScope,
      $mdDialog: angular.material.IDialogService,
      private dataService: Meevo.Components.BaseClasses.IDataService,
      message: string,
      services: any,
      location: any,
      showEmpName: boolean) {

      let vm = this;
      vm.scope = $scope;
      vm.modal = $mdDialog;
      vm.dataService = dataService;

      this.configureModal();

      this.assignPriceLevels();

      this.bookAppointmentSecurityKey = Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_ADDAPPOINTMENT;

    }

    ok = () => {
      this.modal.hide(true);
    }

    cancel = () => {
      this.modal.cancel(false);
    }

    configureModal = () => {
      this.modalClass = "modal-confirm";
      this.headerContentKey = "HEADER_CONFIRM";
      this.okButtonContentKey = "LABEL_YES";
      this.cancelButtonContentKey = "LABEL_NO";
    }

    assignPriceLevels = () => {
      this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.PriceLevelEnum)
        .then((data: any) => {
          _.forEach(this.services, (service: any) => {
            let priceLevel: any = _.findWhere(data, { id: service.employeePriceLevel });
            service.priceLevelDisplayName = (priceLevel ? priceLevel.displayName : "");
          });
          //return data;
        });
    }
  }

  angular.module("meevo.plugins.callCenter")
    .controller("meevo.plugins.callCenter.bookAppointmentModalController", BookAppointmentModalController);
}